import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/App.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import store from './features/store';
import {BrowserRouter} from "react-router-dom";
import "./apiClient/init";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        {/* <React.StrictMode> */}
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        {/* </React.StrictMode> */}
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
